<template lang="pug">
include /mixins
+b.ds-panel--space_2xl
    +b.close-popup.mdi.mdi-close.BUTTON(
      @click.prevent='$emit("close")'
    )
    +e.element--offset_full
      +b.ds-caption--size_lg.--medium.--appearance_center-xl.H2.main-title.tt-space_mb--5 {{ _('Обратите внимание') }}
      +b.cart-conflict-resolver
        +e.text.P {{ _('В вашем заказе есть специальные предложения, которые совпадают с условиями закупки.') }}
        +e.text.P {{ _('Если Вы выбираете «Учесть товары этого предложения в поездку», все скидки, кэшбэки и бонусы могут быть автоматически отменены для тех товаров, которые входят в закупку по условиям выбранной поездки.') }}

        template(
          v-for='(item, i) in conflicts'
        )
          +e.sale.P {{ item.title }}
          v-selection-controller(
            :options='children'
            :multiple='false',
            :key='item.id'
            :key-getter="e => $options.keyGetter(e, item)",
            v-model='values[i]'
            v-slot="{ options, value: model, change }"
          )
            +b.tt-space_mt--3.tt-space_ml--3(v-for='{ value } in options')
              +b.d-control-static-input--appearance_inline.TAG(
                :rules='{ required: { allowFalse: false } }',
                :tag='"input"'
                :input-label='value.title'
                :key='`key_${value.id}`'
                v-model='model'
                :checked.props='model[0] && model[0].id == value.id'
                :id='`channel_${value.id}`'
                :ref='`channel_${value.id}`'
                @change='change(value), updateStrategy(value, item)'
                type='radio'
                name='channel'
              )
              label.input-group__input(
                :for='`channel_${value.id}`'
              ) {{ value.title }}
      +e.btn
        +b.tt-button--bordered_main.--fixed-h.--auto.A(
          @click='promise(result); $emit("close")'
        )
          +e.title.SPAN {{ _('Выбрать') }}
</template>
<script>

const CAMPAIGN_TYPE = 'campaign'
const TRIP_TYPE = 'trip'
const CAMPAIGN_ID = 2
const TRIP_ID = 1
const TRIP = { type: TRIP_TYPE, id: TRIP_ID }
const CAMPAIGN = { type: CAMPAIGN_TYPE, id: CAMPAIGN_ID }

const TYPES = [TRIP, CAMPAIGN]

export default {
  name: 'CartConflictResolve',
  keyGetter: (x, item) => `${item.id}:${x.id}`,
  props: {
    conflicts: {
      type: Array,
      required: true,
    },
    promise: {
      type: Function,
      required: true,
    },
  },
  data() {
    const r = this.conflicts.map(e => [{
      id: TYPES.find(t => t.type === e.calc_strategy).id,
      type: e.calc_strategy,
    }])
    return {
      values: r,
      children: [
        {
          ...TRIP,
          title: this._('Учесть товары этого предложения в поездку'),
        },
        {
          ...CAMPAIGN,
          title: this._('Получить преимущества по акции'),
        },
      ],
      result: {},
    }
  },
  methods: {
    updateStrategy(data, item) {
      this.result[item.id] = data.type
    },
  },
}
</script>
